import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import SessionCard from '../../components/card/session-card';
import hubspot from '../../modules/hubspot';
import { MINIMUM_LOAN_VALUE } from '../../modules/loan-size';
import { BorrowerCard } from '../card-lenses';
import { ContactInfo, nameValidator } from '.';

const MIN_LOAN_LABEL = `$${Math.floor(MINIMUM_LOAN_VALUE / 1000)}k`;

const LoanTooSmallShortCard = ({ onSubmit, ...props }) => (
  <ContactInfo
    {...props}
    onSubmit={
      onSubmit &&
      (() => {
        hubspot.registerLowLoanAmountLead(props.model.get('email'), {
          name: props.model.get('name'),
          scenario: props.scenario,
          /* eslint-disable @typescript-eslint/camelcase */
          loan_state: props.questionnaireState,
          loan_amount: props.loanAmount
          /* eslint-enable @typescript-eslint/camelcase */
        });
        onSubmit();
      })
    }
    buttonType="end"
    title={`Unfortunately, our lenders don't offer loans of ${MIN_LOAN_LABEL} or less. Please leave us your email and we'll send you a note when that changes.`}
  />
);

export const LoanTooSmallContactInfo = SessionCard(
  BorrowerCard(
    LoanTooSmallShortCard,
    'LoanTooSmallContactInfo',
    {},
    ({ model }) =>
      nameValidator(model.get('name')) && emailValidator.validate(model.get('email') || '')
  )
);



// WEBPACK FOOTER //
// ./src/cards/contact-info-short/small-loan.js